/**
 *
 *
 *   WARNING WARNING WARNING
 *   TODO
 *    need to chekc if this is really the structure we want and
 *    where this is used?
 *
 */
import { cloneObject, unique } from '../utilities';
import { getDonutQuillValue, getOldTooltips, getQuillFromFields, getValueSelector } from './base-objects';
const uniqueInVisualFilterTypes = ['valueSelector'];

import { AutoRangeTypes, ColorGroups, DotTypes, EChartTypes, TableTypes, TTLineChartTypes, TypesWithLegend, WaterfallTypes } from '../config/constants';

import { autoApplyCategories } from '../color/colorCategories';
import { getDimensionsConfig, getRightLabelFieldName, getRightLegendFieldName, getValueFieldName } from '../config/dimension.config';
import { ContentInvariants } from '../domain/content/entities/invariants/content.invariants';
import type { Content } from '../domain/content/entities/valueobjects/Content';
import type { DataRows } from '../domain/content/entities/valueobjects/DataRows';
import type { DimensionConfig, DimensionsConfig, UniqueFilter, VisualConfiguration } from '../domain/content/entities/valueobjects/Dimensions';
import type { DataSetFields } from '../domain/content/entities/valueobjects/Fields';
import type { InvisualFilter } from '../domain/content/entities/valueobjects/InvisualFilter';
import { getFields, validateTTLineChart } from './charts23/linechart';
import getLabelsQuill from './charts23/quills/labels';
import getLegendQuill from './charts23/quills/legend';
import getTooltipQuill from './charts23/quills/tooltip';
import getXAxisQuill from './charts23/quills/xAxis';
import { validateEChart } from './echarts/utilities';
import { checkUniqueness, compareFieldTypeOrder, getSortedFieldNamesForUnqiueness } from './uniquenes';
import { table1ToTable2 } from './charts23/table2';

/**
 * Transforms from one visual type to another visual type
 * newVisualConfiguration already has to be in the new type
 * returns content and ewn visualconfiguration
 * content is changed in place
 */
export const transFormContentToType = (content, data, oldVisualConfiguration, newVisualConfiguration) => {
  let newConfig = transformVisualConfigurationFromDifferentType(oldVisualConfiguration, newVisualConfiguration, data, content);

  newConfig.uniqueFilters = [];
  // console.log('First test after Transform: ', cloneObject(tempVisualConfiugration));
  let valid = testVisualConfiugration(newConfig, data, content.typeSpecific.fields);
  newConfig.valid = valid;
  // we wanna reuse the axis parts
  // and the invisual filter parts
  if (!newConfig.valid) {
    // try to use filters from what we have already defined if this part is not in an axis
    newConfig.uniqueFilters = [];
    for (let i = 0; i < oldVisualConfiguration.uniqueFilters.length; i++) {
      // do we have this on an axis
      const uniqueFilter = oldVisualConfiguration.uniqueFilters[i];
      const isUsed = newConfig.dimensions.filter((el) => el.fieldName === uniqueFilter.fieldName).length > 0;
      if (!isUsed) {
        // console.log('pushing old unique filter of last visual', cloneObject(uniqueFilter));
        newConfig.uniqueFilters.push(cloneObject(uniqueFilter));
        valid = testVisualConfiugration(newConfig, data, content.typeSpecific.fields);
        newConfig.valid = valid;
        if (valid) {
          break;
        }
      }
    }
    if (!newConfig.valid) {
      newConfig = makeVisualConfigValid(newConfig, content.typeSpecific.fields, data);
    }
  }
  if (newConfig.valid) {
    applyVisualConfigurationToContent(content, newConfig, data);
    // console.log("BEFORE APPLY",this.currentVisualConfiguration);
    const { type, typeSpecific } = content;
    // disable / enable legend
    // Bars: no legend.Line, area, stacked, grouped, pie: legend.Map wie bisher.
    const typesWithLegend = TypesWithLegend;
    if (typesWithLegend.includes(type)) {
      if (typeSpecific.chart?.legend) {
        typeSpecific.chart.legend.enabled = true;
      }
    } else {
      if (typeSpecific.chart?.legend) {
        typeSpecific.chart.legend.enabled = false;
      }
    }
  }

  return {
    newConfig,
    content,
  };
};

/**
 * Changes the field of a dimension by given a new Dimension with new field
 * changes visulConfig and content in place
 * @param content
 * @param currentVisualConfiguration
 * @param data
 * @param newDimension
 * @returns
 */
export const changeDimension = (content, currentVisualConfiguration: VisualConfiguration, data: DataRows, newDimension) => {
  const backupUniqueFilters = cloneObject(currentVisualConfiguration.uniqueFilters);
  currentVisualConfiguration = switchVisualConfigurationDimensions(currentVisualConfiguration, newDimension);
  // reset the invisualFilters
  currentVisualConfiguration.uniqueFilters = [];
  const valid = testVisualConfiugration(currentVisualConfiguration, data, content.typeSpecific.fields);
  currentVisualConfiguration.valid = valid;
  if (!currentVisualConfiguration.valid) {
    currentVisualConfiguration = makeVisualConfigValid(currentVisualConfiguration, content.typeSpecific.fields, data);
  }
  // try to use settings of old uniqueFilters also for invisual parts
  if (currentVisualConfiguration.valid && backupUniqueFilters && backupUniqueFilters.length > 0) {
    for (const uniqueFilter of backupUniqueFilters) {
      const inConfigFilter = currentVisualConfiguration.uniqueFilters.find((el) => el.fieldName === uniqueFilter.fieldName);
      if (inConfigFilter) {
        inConfigFilter.filterObj = cloneObject(uniqueFilter.filterObj);
        inConfigFilter.inVisual = uniqueFilter.inVisual;
      }
    }
  }
  if (currentVisualConfiguration.valid) {
    applyVisualConfigurationToContent(content, currentVisualConfiguration, data);
  }
  return {
    content,
    visualConfig: currentVisualConfiguration,
  };
};

/**
  not same field in two dimensions
 */
export const switchVisualConfigurationDimensions = (visualConfiguration: VisualConfiguration, changedDimension) => {
  for (const dimension of visualConfiguration.dimensions) {
    if (dimension.dimName !== changedDimension.dimName && dimension.fieldName === changedDimension.fieldName) {
      dimension.fieldName = dimension.possibleFields.filter((el) => el.fieldName !== dimension.fieldName)[0].fieldName;
    }
  }
  return visualConfiguration;
};

/**
 * most important function for typeswitch now
 * does all the magic
 */
export const applyVisualConfigurationToContent = (content, visualConfiguration: VisualConfiguration, data: DataRows, formattingChanges = true) => {
  //backup old chartFields
  const backUpValueFieldName = getValueFieldName(content?.typeSpecific?.dimensions);
  const backUpLabelFieldName = getRightLabelFieldName(content.type, content?.typeSpecific?.dimensions);
  const backUpLegendFieldName = getRightLegendFieldName(content.type, content?.typeSpecific?.dimensions);
  //backup color settings for type and dimension
  if (backUpLegendFieldName && backUpValueFieldName) {
    const backupColorUniqueID = ColorGroups[content.type] + backUpLegendFieldName + backUpValueFieldName; //content.type+content.typeSpecific.dimensions.map(el=>el.fieldName).join("_");
    if (!content.localStorage) {
      content.localStorage = {};
    }
    if (!content.localStorage.colorBackup) {
      content.localStorage.colorBackup = {};
    }
    content.localStorage.colorBackup[backupColorUniqueID] = {
      color2: cloneObject(content.typeSpecific.style.colors2),
    };
  }
  // set is needed for uniqueNess false for all fields
  const backupUniqueFilterValues = {};
  for (const fieldName of Object.keys(content.typeSpecific.fields)) {
    const field = content.typeSpecific.fields[fieldName];
    if (field.isNeededForUniqueness) {
      // console.log('DESELECTING FORMERY SELECTED FIELD');
      backupUniqueFilterValues[fieldName] = cloneObject(field.selectedValues);
      field.isNeededForUniqueness = false;
      //field.selectedValues = [];
    }
  }

  const invisualFilters: InvisualFilter[] = [];
  // for unique editor filters apply
  for (const uniqueFilter of visualConfiguration.uniqueFilters) {
    if (!uniqueFilter.inVisual) {
      if (backupUniqueFilterValues[uniqueFilter.fieldName]) {
        content.typeSpecific.fields[uniqueFilter.fieldName].isNeededForUniqueness = true;
        content.typeSpecific.fields[uniqueFilter.fieldName].selectedValues = backupUniqueFilterValues[uniqueFilter.fieldName];
      } else {
        const uniqueValues = unique(data.map((obj) => obj[uniqueFilter.fieldName]));
        const selectedValue = uniqueValues[0];
        if (selectedValue !== null && selectedValue !== undefined) {
          content.typeSpecific.fields[uniqueFilter.fieldName].isNeededForUniqueness = true;
          content.typeSpecific.fields[uniqueFilter.fieldName].selectedValues = [selectedValue];
        }
      }
    } else {
      let filterObj = {} as UniqueFilter | InvisualFilter;
      if (uniqueFilter.filterObj) {
        filterObj = uniqueFilter.filterObj;
      } else {
        filterObj = getValueSelector(uniqueFilter.fieldName, 'timeline');
      }

      invisualFilters.push(filterObj);
    }
  }

  content.type = visualConfiguration.type;
  //unique filters
  content.typeSpecific.dimensions = visualConfiguration.dimensions;

  //get all invisual filers that are multivalue
  const multiValueFilters = content.typeSpecific.inVisualFilter.filter((el) => el.type === 'multiValueSelector');
  content.typeSpecific.inVisualFilter = [...invisualFilters, ...multiValueFilters];

  // EChart Sankey
  if (EChartTypes.includes(content.type)) {
    validateEChart(content);
  }

  // Table v2
  if (content.type === 'table2') {
    content.typeSpecific.style.colors2.type = 'gradient';    
    content.typeSpecific.table2 = content.typeSpecific.table2 ?? table1ToTable2(content.typeSpecific.table, content.typeSpecific.fields)
  }

  // Reset valueRange
  const { valueRange } = content.typeSpecific.data;
  if (valueRange?.type === 'auto' && !AutoRangeTypes.includes(content.type)) {
    valueRange.type = 'active';
    valueRange.range = [0, 0];
  }

  if (formattingChanges && !TableTypes.includes(content.type) && !EChartTypes.includes(content.type)) {
    const currentValueFieldName = getValueFieldName(content?.typeSpecific?.dimensions);
    const currentLabelFieldName = getRightLabelFieldName(content.type, content?.typeSpecific?.dimensions);
    const currentLegendFieldName = getRightLegendFieldName(content.type, content?.typeSpecific?.dimensions);
    const currentLabelField = content.typeSpecific.fields[currentLabelFieldName];
    const currentValueField = content.typeSpecific.fields[currentValueFieldName];
    // tooltips

    const tooltips = getOldTooltips(content.typeSpecific.fields, currentLabelFieldName, currentValueFieldName);
    if (content.typeSpecific.tooltip.titleStyle) {
      tooltips.titleStyle = content.typeSpecific.tooltip.titleStyle;
    }
    if (content.typeSpecific.tooltip.valueStyle) {
      tooltips.valueStyle = content.typeSpecific.tooltip.valueStyle;
    }
    if (content.typeSpecific.tooltip.value) {
      tooltips.contentStyle = content.typeSpecific.tooltip.contentStyle;
    }
    if (content.typeSpecific.tooltip.theme) {
      tooltips.theme = content.typeSpecific.tooltip.theme;
    }
    //make name be the same
    if (content.typeSpecific.tooltip.name) {
      tooltips.name = content.typeSpecific.tooltip.name;
    }
    //if old tooltip additonal values exist keep them!
    if (content.typeSpecific.tooltip.fields && content.typeSpecific.tooltip.fields.length > 0) {
      tooltips.fields = content.typeSpecific.tooltip.fields;
    }
    //now about the value field itself if old one === new one then just keep
    //label and format
    if (content.typeSpecific.tooltip.value && content.typeSpecific.tooltip.value.field === tooltips.value.field) {
      tooltips.value.label = content.typeSpecific.tooltip.value.label;
      tooltips.value.format = content.typeSpecific.tooltip.value.format;
    }
    content.typeSpecific.tooltip = tooltips;
    // chart.sorting - we could compare if the sorting has at least
    //the field in it if yes otherwise push it in sortFields only has one in
    //atm
    const sortFields: string[] = [];
    for (const fieldName of content.typeSpecific.chart.sorting.sortFields) {
      if (content.typeSpecific.fields[fieldName]) {
        sortFields.push(fieldName);
      }
    }
    content.typeSpecific.chart.sorting.sortFields = sortFields;
    // chart.axis

    //advanced tooltip -- if value field has changed
    if (content.typeSpecific?.advancedTooltip?.content) {
      //check if this is standard
      const advancedTooltipContent = JSON.parse(content.typeSpecific.advancedTooltip.content);
      //filter to inserts
      const valueInserts = advancedTooltipContent.ops.filter((obj) => typeof obj.insert === 'object' && obj.insert.inlineValue);
      //unmodified
      if (valueInserts.length === 2) {
        //first one is label second one is value field
        //{ insert { inlineValue: { fieldName, title, format} }
        if (valueInserts[0].insert.inlineValue.fieldName === backUpLabelFieldName) {
          valueInserts[0].insert.inlineValue.fieldName = currentLabelFieldName;
          valueInserts[0].insert.inlineValue.title = content.typeSpecific.fields[currentLabelFieldName].title;
          valueInserts[0].insert.inlineValue.format = cloneObject(content.typeSpecific.fields[currentLabelFieldName].format);
        }
        if (valueInserts[1].insert.inlineValue.fieldName === backUpValueFieldName) {
          valueInserts[1].insert.inlineValue.fieldName = currentValueFieldName;
          valueInserts[1].insert.inlineValue.title = content.typeSpecific.fields[currentValueFieldName].title;
          valueInserts[1].insert.inlineValue.format = cloneObject(content.typeSpecific.fields[currentValueFieldName].format);
        }
        content.typeSpecific.advancedTooltip.content = JSON.stringify(advancedTooltipContent);
      }
    }

    const isLabelChanged = currentLabelFieldName !== backUpLabelFieldName;
    const isGroupChanged = currentLegendFieldName !== backUpLegendFieldName;
    const isValueChanged = currentValueFieldName !== backUpValueFieldName;

    // console.log("[Creator] - apply to content oldfields: ",backUpLabelFieldName,backUpValueFieldName,backUpLegendFieldName," new: ",currentLabelFieldName,currentValueFieldName,currentLegendFieldName);
    if (isLabelChanged) {
      //format and qull value

      const quillValue = getQuillFromFields([currentLabelField]);
      content.typeSpecific.chart.axis.labelAxis.format = cloneObject(currentLabelField.format);
      content.typeSpecific.chart.axis.labelAxis.quillValue = quillValue;
    }

    if (isGroupChanged) {
      //CODE DIARIES for history reasons the legend is
      //not always set via the label (who knows why)
      content.typeSpecific.chart.legend.format = cloneObject(content.typeSpecific.fields[currentLegendFieldName].format);
    }

    //change donut wysiwigvalue if either label or valuefield has changed
    if (isLabelChanged || isValueChanged) {
      if (content?.typeSpecific?.chart?.donut?.quillValue) {
        content.typeSpecific.chart.donut.quillValue = getDonutQuillValue(currentLabelField, currentValueField);
      }
    }

    if (isValueChanged) {
      // content.typeSpecific.chart.axis.valueAxis = valueAxis;
      content.typeSpecific.chart.axis.valueAxis.format = cloneObject(currentValueField.format);
      // chart values
      content.typeSpecific.chart.values.format = cloneObject(currentValueField.format);
      const quillValue = JSON.stringify({
        ops: [
          {
            insert: {
              inlineValue: {
                fieldName: currentValueField.fieldName,
                title: currentValueField.title,
                format: cloneObject(currentValueField.format),
              },
            },
          },
          {
            attributes: {
              align: 'center',
            },
            insert: '\n',
          },
        ],
      });

      content.typeSpecific.chart.values.quillValue = quillValue;

      // map.legend.values
      // map.legend.title
      if (content.typeSpecific.map?.legend) {
        content.typeSpecific.map.legend.values.format = cloneObject(currentValueField.format);
        //title format actually is done by value field since it is only applied
        //to sum average and so on fields
        content.typeSpecific.map.legend.title.format = cloneObject(currentValueField.format);
      }
      // console.log("AFTER", content);
    }

    // Legend Quill transform
    if (isGroupChanged && currentLegendFieldName) {
      const field = content.typeSpecific.fields[currentLegendFieldName];
      content.typeSpecific.chart.legend.quillValue = getQuillFromFields([field]);
    }

    // Applying new value field to color settings
    if (content.typeSpecific.style.colors2) {
      // style area chart und linechart → disable range coloring
      if (content.type === 'areachart' || content.type === 'linechart') {
        if (content.typeSpecific.style?.colors2) {
          if (content.typeSpecific.style.colors2.type === 'range') {
            content.typeSpecific.style.colors2.type = 'continuous';
          }
        }
      }

      //coloring defaults
      const { colors2 } = content.typeSpecific.style;
      //base colorfield
      colors2.fieldName = currentValueFieldName;
      //colors are depending on
      //chart type - and dimensions
      const currentColorUniqueId = ColorGroups[content.type] + currentLegendFieldName + currentValueFieldName;
      let found = false;
      if (content.localStorage.colorBackup?.[currentColorUniqueId]) {
        //console.log('[Content] Restore Colors ');
        content.typeSpecific.style.colors2 = cloneObject(content.localStorage.colorBackup[currentColorUniqueId].color2);
        found = true;
      }
      if (!found) {
        switch (ColorGroups[content.type]) {
          case 'categorical':
            {
              //console.log('[TypeSwitchEvaluating] Colors setting to categorical');
              colors2.type = 'categorical';
              if (!colors2.categorical.fallback) {
                colors2.categorical.fallback = colors2.activeColors[0];
              }
              colors2.categorical.fieldName = currentLegendFieldName;
              const labels = unique(data.map((el) => el[currentLegendFieldName]));
              //console.log('[Labels]', labels);
              autoApplyCategories(colors2, colors2.activeColors, labels);
            }
            break;
          case 'solid':
            content.typeSpecific.style.colors2.type = 'solid';
            break;
          case 'continuous':
            content.typeSpecific.style.colors2.type = 'continuous';
            break;
          default:
            console.log(`[colorgroups] no part found for ${ColorGroups[content.type]}`);
            break;
        }
      }
    }

    // Assure no waterfall in other types than WaterfallTypes
    if (!WaterfallTypes.includes(content.type) && content.typeSpecific.chart?.waterfall) {
      content.typeSpecific.chart.waterfall.enabled = false;
    }    

    if (isLabelChanged || isGroupChanged || isValueChanged) {
      if (TTLineChartTypes.includes(content.type)) {
        validateTTLineChart(content);

        const { labelField, xAxisField, yAxisField } = getFields(content.typeSpecific.dimensions);
        // console.log('🚀 ~ { labelField, xAxisField, yAxisField }:', { labelField, xAxisField, yAxisField });

        // Update X Axis Labels Quill
        content.typeSpecific.charts23.lineChart.axis[0].labelsQuill.quill = JSON.stringify(getXAxisQuill(xAxisField, content.typeSpecific.fields));
        // Update Y Axis Labels Quill
        content.typeSpecific.charts23.lineChart.axis[1].labelsQuill.quill = JSON.stringify(getXAxisQuill(yAxisField, content.typeSpecific.fields));
        // Update Labels Quill
        content.typeSpecific.charts23.lineChart.labels.labelsQuill.quill = JSON.stringify(
          getLabelsQuill(labelField, xAxisField, yAxisField, content.typeSpecific.fields),
        );
        // Update Labels Quill
        content.typeSpecific.charts23.lineChart.legend.labelsQuill.quill = JSON.stringify(
          getLegendQuill(labelField, xAxisField, yAxisField, content.typeSpecific.fields),
        );
        // Update Labels Quill
        content.typeSpecific.charts23.lineChart.tooltip.labelsQuill.quill = JSON.stringify(
          getTooltipQuill(labelField, xAxisField, yAxisField, content.typeSpecific.fields),
        );
      }
    }

    //ensuring invariantes
    ContentInvariants.ensureBubbleMapInvariants(content);
    ContentInvariants.ensureExtrudeMapInvariants(content);
    ContentInvariants.ensureChoroplethMapInvariants(content);
    ContentInvariants.ensureParliamentInvariants(content);
    ContentInvariants.ensurePieInvariants(content);
  }

  return content;
};

export const generateVisualConfigurationFromContent = (content, data: DataRows): VisualConfiguration => {
  const requiredDimensions = getDimensionsConfig(content.type);
  const visualConfiguration: VisualConfiguration = {
    type: content.type,
    valid: true,
    dimensions: requiredDimensions,
    uniqueFilters: [],
  };

  const contentDimensions = content.typeSpecific?.dimensions;
  // recreate Possible Fields and fieldName
  for (const dimension of visualConfiguration.dimensions) {
    dimension.possibleFields = getPossibleFieldsForDimension(dimension, content.typeSpecific.fields);
    //set fieldname of content
    if (!contentDimensions) continue;
    const contentDimension = contentDimensions.find((el) => el.dimName === dimension.dimName);
    if (!contentDimension) continue;

    if (dimension.possibleFields.find((_field) => _field.fieldName === contentDimension.fieldName)) {
      dimension.fieldName = contentDimension.fieldName;
    } else {
      dimension.fieldName = dimension.possibleFields[0].fieldName;
    }
  }

  //get the current filters from the editor
  for (const fieldName of Object.keys(content.typeSpecific.fields)) {
    const field = content.typeSpecific.fields[fieldName];
    // console.log("[Creator] - Testing editor Unique Filter",field);
    if (field.isNeededForUniqueness) {
      visualConfiguration.uniqueFilters.push({
        fieldName: fieldName,
        fieldTitle: field.title,
        possibleFields: Object.keys(content.typeSpecific.fields)
          .filter(
            (el) =>
              content.typeSpecific.fields[el].fieldType === 'miscField' ||
              content.typeSpecific.fields[el].fieldType === 'timeField' ||
              content.typeSpecific.fields[el].fieldType === 'isoLabelField',
          )
          .map((el) => {
            return { fieldName: content.typeSpecific.fields[el].fieldName, title: content.typeSpecific.fields[el].title };
          }),
        inVisual: false,
        filterObj: getValueSelector(fieldName, 'timeline'),
      });
    }
  }
  // look into inVisualFilter For valueFilters
  //do we have it 2 times in there?
  for (const inVisualFilter of content.typeSpecific.inVisualFilter) {
    if (uniqueInVisualFilterTypes.includes(inVisualFilter.type)) {
      visualConfiguration.uniqueFilters.push({
        fieldName: inVisualFilter.fieldName,
        fieldTitle: content.typeSpecific.fields[inVisualFilter.fieldName].title,
        possibleFields: Object.keys(content.typeSpecific.fields)
          .filter(
            (el) =>
              content.typeSpecific.fields[el].fieldType === 'miscField' ||
              content.typeSpecific.fields[el].fieldType === 'timeField' ||
              content.typeSpecific.fields[el].fieldType === 'isoLabelField',
          )
          .map((el) => {
            return { fieldName: content.typeSpecific.fields[el].fieldName, title: content.typeSpecific.fields[el].title };
          }),
        inVisual: true,
        filterObj: cloneObject(inVisualFilter),
      });
    }
  }
  return visualConfiguration;
};

/**
 * Tries to make the visualConfiguration
 * valid by adding more uniqueFilters
 * @param visualConfiguration
 * @param fields
 * @param data
 * @returns visualConfiguration
 */
export const makeVisualConfigValid = (visualConfiguration: VisualConfiguration, fields: DataSetFields, data: DataRows): VisualConfiguration => {
  const loops = Object.keys(fields).length - visualConfiguration.dimensions.length;
  const uniqueCount = undefined;
  // console.log('[uniqueCount] finished after: ', Date.now() - start); //, uniqueCount
  for (let i = 0; i < loops; i++) {
    visualConfiguration = addUniqueFilterToVisualConfigurationAndTest(visualConfiguration, fields, data, uniqueCount);
    if (visualConfiguration.valid) {
      //sometimes too many fields are chosen which arent even needed to get uniqueness
      visualConfiguration = backTrackUniquenessCheck(visualConfiguration, fields, data);
      break;
    }
  }
  return visualConfiguration;
};

const addUniqueFilterToVisualConfigurationAndTest = (visualConfiguration, fields: DataSetFields, data, uniqueCount = undefined) => {
  if (visualConfiguration.dimensions.length === 0) {
    visualConfiguration.valid = true;
    return visualConfiguration;
  }

  if (!uniqueCount) {
    //console.log('[addUniqueFilterToVisualConfigurationAndTest] - ', visualConfiguration, data.length);
    // try unique filter
    const allfieldNames = getSortedFieldNamesForUnqiueness(fields);
    //we have information about

    // console.log('ordered fieldNames: ', allfieldNames);
    let usedFields = visualConfiguration.dimensions.filter((el) => el.fieldName !== undefined).map((el) => el.fieldName);
    // add old uniqueFilters into this
    usedFields = usedFields.concat(visualConfiguration.uniqueFilters.map((el) => el.fieldName));
    // console.log('used Fields', usedFields);
    let notUsedField = null;
    for (const field of allfieldNames) {
      // console.log('Checking for field: ', field);
      if (!usedFields.includes(field.fieldName)) {
        notUsedField = field.fieldName;
        break;
      }
    }
    // console.log('not used Fields', notUsedField);
    if (!notUsedField) {
      return visualConfiguration;
    }

    visualConfiguration.uniqueFilters.push({
      fieldName: notUsedField,
      possibleFields: allfieldNames,
      fieldTitle: fields[notUsedField].title,
      inVisual: true,
      filterObj: getValueSelector(notUsedField, 'dropdown'),
    });
    const valid = testVisualConfiugration(visualConfiguration, data, fields);
    visualConfiguration.valid = valid;
    //console.log("[Creator] - VisualConfiguration after ADD: ",cloneObject(visualConfiguration));
    return visualConfiguration;
  }

  const startDate = Date.now();
  let usedFields = visualConfiguration.dimensions.filter((el) => el.fieldName !== undefined).map((el) => el.fieldName);
  let joker = false;
  // add old uniqueFilters into this
  usedFields = usedFields.concat(visualConfiguration.uniqueFilters.map((el) => el.fieldName));
  const allFieldNames = Object.keys(fields);
  let potentialUniqueFields: any[] = [];
  for (const fieldName of allFieldNames) {
    const field = fields[fieldName];
    //penalize auto23degreesindex
    if (['miscField', 'isoLabelField', 'timeField'].includes(field.fieldType)) {
      potentialUniqueFields.push({
        fieldName: fieldName,
        distinct: uniqueCount[fieldName].distinct, //fieldName ==='auto23degreesindex'?0:uniqueCount[fieldName].distinct,
        count: uniqueCount[fieldName].count,
      });
    }
  }

  const potentialGroupFields = [];
  //we have to first look at the fields already in use to calculate the rows we need to divide
  if (potentialUniqueFields.length > 0) {
    potentialUniqueFields.sort((a, b) => b.distinct - a.distinct); // desc
    let rowsToDivide = data.length;
    for (const field of potentialUniqueFields) {
      if (field.distinct > rowsToDivide * 2) continue;
      if (field.fieldName === 'auto23degreesindex') continue;

      // TODO this is inaccurate, maybe calc the rest and add it back?
      rowsToDivide = Math.ceil(rowsToDivide / field.distinct);
      // console.log('field', field.fieldName, 'distinct', field.distinct, 'rowsToDivide', rowsToDivide);

      if (rowsToDivide > 1 && field.distinct > 1) {
        potentialGroupFields.push(field.fieldName);
      }

      if (rowsToDivide === 1) {
        potentialGroupFields.push(field.fieldName);
        break;
      }
    }
    if (rowsToDivide > 1) {
      console.log('UNIQUENESS ERROR rowsToDivide', rowsToDivide, potentialUniqueFields, potentialGroupFields);
    }
  }

  let uniqueFilterFields = potentialGroupFields.filter((obj) => !usedFields.includes(obj));
  if (uniqueFilterFields.includes('auto23degreesindex')) {
    joker = true;
    uniqueFilterFields = uniqueFilterFields.filter((obj) => obj !== 'auto23degreesindex');
  }

  if (uniqueFilterFields.length > 0) {
    //remove fields that are alread used in dimensions
    visualConfiguration.uniqueFilters.push({
      fieldName: uniqueFilterFields[0],
      possibleFields: getSortedFieldNamesForUnqiueness(fields),
      fieldTitle: fields[uniqueFilterFields[0]].title,
      inVisual: true,
      filterObj: getValueSelector(uniqueFilterFields[0], 'dropdown'),
    });
    const valid = testVisualConfiugration(visualConfiguration, data, fields);
    visualConfiguration.valid = valid;
    //console.log('add right unique filter finished after: ', Date.now() - startDate);
    //console.log("[Creator] - VisualConfiguration after ADD: ",cloneObject(visualConfiguration));
    return visualConfiguration;
  }

  if (joker) {
    //remove fields that are alread used in dimensions
    visualConfiguration.uniqueFilters.push({
      fieldName: 'auto23degreesindex',
      possibleFields: getSortedFieldNamesForUnqiueness(fields),
      fieldTitle: fields['auto23degreesindex'].title,
      inVisual: true,
      filterObj: getValueSelector('auto23degreesindex', 'dropdown'),
    });
    const valid = testVisualConfiugration(visualConfiguration, data, fields);
    visualConfiguration.valid = valid;
    console.log('add joker finished after: ', Date.now() - startDate);
  }
  console.log('UNIQUENESS ERROR - no more unique filers to add');
  return visualConfiguration;
};

/**
 * transforms Axis to new VisualConfiguration -> doesnt deal with uniqueFilters
 * @param  oldVisualConfiguration  Template visual configuration
 * @param  newVisualConfiguration
 * @parm   data                     source data
 * @param  content                  content item
 * @return new Visual Configuration
 */
const transformVisualConfigurationFromDifferentType = (
  oldVisualConfiguration: VisualConfiguration,
  newVisualConfiguration: VisualConfiguration,
  data,
  content,
) => {
  /**
   * - Map:
   *      - Region  (IsoLabelField)
   *      - Value   (Value Axis)
   *  - Barchart:
   *      - X - Axis  (as Region)
   *      - Y - Axis  (Value Axis)
   *  - Horizontal Barchart:
   *      - Y - Axis ( Region = X Axis from others)
   *      - X - Axis ( Value Axis )
   *
   *  - Grouped and Stacked
   *      - X - Axis ( Region )
   *      - Stacks = Groups
   *  - Stacked and linechart
   *      - Series = groups = stacks
   *
   *  - Donut -> X Axis and such
   */
  // console.log("[Creator] - transformVisualConfigurationFromDifferentType : ",oldVisualConfiguration,newVisualConfiguration);
  let index = 0;
  const usedFields: string[] = [];
  for (const dimension of newVisualConfiguration.dimensions) {
    // axis are applied in the order the come in the array
    // value Field parts shall be reused
    if (dimension.requirements.fieldTypes.includes('valueField')) {
      // lets find the respective dimension in oldVisualConfiguration
      const oldValueDimension = oldVisualConfiguration.dimensions.find((el) => el.requirements.fieldTypes.includes('valueField'));
      if (oldValueDimension) {
        dimension.fieldName = oldValueDimension.fieldName;
      }

      usedFields.push(dimension.fieldName);
    } else {
      const oldDimension = oldVisualConfiguration.dimensions[index];
      const oldField = content.typeSpecific.fields[oldDimension?.fieldName];
      if (oldDimension && oldField && dimension.requirements.fieldTypes.includes(oldField.fieldType)) {
        dimension.fieldName = oldDimension.fieldName;
        usedFields.push(dimension.fieldName);
      } else {
        // can we just leave the current dimension?
        if (!usedFields.includes(dimension.fieldName)) {
          usedFields.push(dimension.fieldName);
        } else {
          // try to find a different field from the potential fields part
          const freeField = dimension.possibleFields.find((el) => !usedFields.includes(el.fieldName));
          if (freeField) {
            dimension.fieldName = freeField.fieldName;
            usedFields.push(dimension.fieldName);
          } else {
            console.error("[Creator] Error couldnt't find free field ", newVisualConfiguration, dimension);
          }
        }
      }
    }

    index = index + 1;
  }

  return newVisualConfiguration;
};

export const testVisualConfiugration = (visualConfiguration: VisualConfiguration, data: DataRows, fields: DataSetFields) => {
  const fieldNameListForUniqueCheck = [];
  if (visualConfiguration.dimensions.length === 0) return true;
  if (visualConfiguration.dimensions.filter((dim) => dim.usedForUniqueness).length === 0) return true;

  for (const dimension of visualConfiguration.dimensions) {
    // console.log('DIMENSION: CHECK: ', dimension);
    if (!fieldNameListForUniqueCheck.includes(dimension.fieldName) && dimension.usedForUniqueness) {
      fieldNameListForUniqueCheck.push(dimension.fieldName);
    }
  }

  // filter out unique filters
  for (const filter of visualConfiguration.uniqueFilters) {
    if (!fieldNameListForUniqueCheck.includes(filter.fieldName)) {
      fieldNameListForUniqueCheck.push(filter.fieldName);
    }
  }

  // console.log("[Creator] - Checking uniqueness on fields: ",fieldNameListForUniqueCheck,visualConfiguration);
  const isUnique = checkUniqueness(data, fieldNameListForUniqueCheck, fields);
  return isUnique;
};

/**
 * given a fields object and a type
 * checks wether assigning fields for each axis is possible
 * and returns a specific dimension configuration
 * the dimensions are assigned with topic ordering (geo > time > misc)
 */
export const checkDimension = (fields: DataSetFields, type): { fulfilled: boolean; dimensions: DimensionsConfig } => {
  const requiredDimensions = getDimensionsConfig(type);
  const returnObject: { fulfilled: boolean; dimensions: DimensionsConfig } = {
    fulfilled: false,
    dimensions: [],
  };

  const fieldNames = Object.keys(fields)
    .map((el) => {
      let order = 0;
      if (fields[el].fieldType === 'isoLabelField') order = 3;
      if (fields[el].fieldType === 'timeField') order = 2;
      if (fields[el].fieldType === 'miscField') order = 1;
      return { fieldName: el, order: order };
    })
    .sort(compareFieldTypeOrder)
    .map((el) => el.fieldName);

  if (requiredDimensions && requiredDimensions.length > 0) {
    // console.log('checking dimension ', fields, type, requiredDimensions);
    const usedFields: string[] = [];
    for (const requiredDimension of requiredDimensions) {
      // add this to the return object
      const dimension: DimensionConfig = cloneObject(requiredDimension);
      dimension.possibleFields = [];
      // is this in the fieldType
      let found = false;
      const requirement = requiredDimension.requirements;

      for (const fieldName of fieldNames) {
        const field = fields[fieldName];

        if (EChartTypes.includes(type) && field.autoGenerated) continue;

        if (requirement.fieldTypes && !requirement.fieldTypes.includes(field.fieldType)) {
          continue;
        }

        if (!found && !usedFields.includes(fieldName)) {
          dimension.fieldName = fieldName;
          dimension.possibleFields.push({
            fieldName: field.fieldName,
            title: field.title,
          });

          usedFields.push(fieldName);
          found = true;
        } else {
          dimension.possibleFields.push({
            fieldName: field.fieldName,
            title: field.title,
          });
        }
      }
      returnObject.dimensions.push(dimension);
    }

    // do we have fullfillment
    if (usedFields.length === requiredDimensions.length) {
      returnObject.fulfilled = true;
    }
  } else {
    //no dimensions are required for example for table - thats ok and good
    returnObject.fulfilled = true;
  }
  // console.log('[checkDimension] return config:  ', returnObject);
  // console.log(`[checkDimension] ${type}`, returnObject.fulfilled);
  return returnObject;
};

/**
 * does type Checks for data ; carefull changes data in place
 */
export const validatedataItSelf = (fields: DataSetFields, data) => {
  // make sure data is really in the right format
  for (const columnName of Object.keys(fields)) {
    const field = fields[columnName];
    switch (field.dataType) {
      case 'string':
        data = data.map((row) => {
          if (row[field.fieldName]) {
            row[field.fieldName] = row[field.fieldName].toString();
            // row[field.fieldName] = row[field.fieldName].toString().trim();
          } else {
            row[field.fieldName] = null;
          }
          return row;
        });
        break;
      case 'number':
        data = data.map((row) => {
          const floatVal = parseFloat(row[field.fieldName]);
          if (Number.isNaN(floatVal)) {
            row[field.fieldName] = null;
          } else {
            row[field.fieldName] = floatVal;
          }
          return row;
        });
        break;
      case 'date':
        data = data.map((row) => {
          row[field.fieldName] = row[field.fieldName].toString().trim();
          return row;
        });
        break;
      case 'object':
        data = data.map((row) => {
          row[field.fieldName] = cloneObject(row[field.fieldName]);
          return row;
        });
        break;
      default:
        console.log('ERROR DATA TYPE: ', field.dataType, field);
    }
    // delete field.localStorage;
  }
};

const backTrackUniquenessCheck = (visualConfiguration: VisualConfiguration, fields: DataSetFields, data: DataRows) => {
  //we have a visualConfiguration that is valid
  //get the fields used
  let validVisualConfiguration = cloneObject(visualConfiguration);
  if (visualConfiguration.dimensions.length === 0) {
    return visualConfiguration;
  }
  const usedFields = visualConfiguration.uniqueFilters.map((el) => el.fieldName);
  //can we remove some fields
  if (usedFields.length > 1) {
    //console.log('[backTrackUniquenessCheck] - more than 1 field found ', usedFields.length, usedFields);
    //can we remove a field?
    for (const fieldName of usedFields) {
      const visualConfigurationBackup = cloneObject(validVisualConfiguration);
      const filterIndex = visualConfigurationBackup.uniqueFilters.findIndex((el) => el.fieldName === fieldName);
      if (filterIndex > -1) {
        visualConfigurationBackup.uniqueFilters.splice(filterIndex, 1);
        const valid = testVisualConfiugration(visualConfigurationBackup, data, fields);
        //console.log('[backTrackUniquenessCheck] - removed: ', fieldName, ' valid: ', valid);
        if (valid) {
          visualConfigurationBackup.valid = true;
          validVisualConfiguration = visualConfigurationBackup;
        }
      }
    }
  }

  return validVisualConfiguration;
};

/**
 * get Possible fields input dimension and content
 * returns a list of possible fields for this dimension
 */
const getPossibleFieldsForDimension = (dimension: DimensionConfig, fields: DataSetFields) => {
  const possibleFields: { fieldName: string; title: string }[] = [];
  for (const fieldName of Object.keys(fields)) {
    const field = fields[fieldName];
    if (dimension.requirements.fieldTypes && !dimension.requirements.fieldTypes.includes(field.fieldType)) {
      continue;
    }

    possibleFields.push({
      fieldName: field.fieldName,
      title: field.title,
    });
  }

  return possibleFields;
};
